import { InputContainer } from '../../global/styles';
import { AddOn, AddOnInput, AddOnInputContainer, Label } from '../../global/styles';

interface Props {
	value: number;
	onChange: (value: number) => void;
}

export default function RepeatInput({ onChange, value }: Props) {
	return (
		<InputContainer>
			<Label>Repeat section</Label>
			<AddOnInputContainer>
				<AddOnInput
					type="number"
					min={1}
					max={4}
					value={value}
					onChange={e => onChange(e.target.valueAsNumber)}
				/>
				<AddOn>time{value > 1 && 's'}</AddOn>
			</AddOnInputContainer>
		</InputContainer>
	);
}
